<template>
  <div class="bookstore-detail">
    <div class="top_back"></div>
    <div class="book-introduction">
      <div class="left-demo-card">
        <div class="left-demo-body">
          <div class="left-demo-tag">
            <img src="../../assets/images/bookdetail/tag.png" alt="">
            {{ callDictionaries(goodsTypeList, goodsInfo.resourceType) }}
          </div>
          <div class="left-img-box flex-center">
            <img :src="coverFiles.length > 0 ? coverFiles[currImg].fullUrl : ''" alt="" />
          </div>
          <div class="left-small-img">
            <img v-for="(item, index) in coverFiles" :key="index + Math.random()" :src="item.fullUrl"
              :class="index == currImg ? 'demo-card-box-img-checked' : ''" @click="changeSrc(index)" alt="" />
          </div>
        </div>
        <!-- <div class="left-demo-bottom">
          <div @click="addBookshelf()">
            <img :src="require('@/assets/icon/book1' +
              (isBookshelf ? 'ed.png' : '.png'))
              " alt="" />
            {{ isBookshelf ? "已加入书架" : "加入书架" }}
          </div>
        </div> -->
      </div>
      <div class="right-info">
        <div class="title">{{ goodsInfo.goodsTitle }}
        </div>
        <div class="book-intro" v-if="goodsInfo.authorRecommendation">
          <div class="defaultIntro" @mouseenter="enterShow" @mouseleave="leaveShow">
            <span class="twointro">{{ goodsInfo.authorRecommendation | ellipsis(117) }}
              <span class="font" v-if="goodsInfo.authorRecommendation.length > 117">更多</span></span>
            <div v-if="showMore" class="allIntro">
              <span>{{ goodsInfo.authorRecommendation }}</span>
            </div>
          </div>
        </div>
        <div class="label">
          <span v-for="(item, index) in keyword" :key="index" class="label_item">
            <img src="../../assets/images/bookdetail/labelTag.png" alt="">
            {{ item }}</span>
        </div>
        <div class="book-intro-info">
          <div v-if="
            goodsInfo.goodsType != 'paper' &&
            goodsInfo.goodsType != 'reference' &&
            goodsInfo.goodsType != 'other'
          ">
            <span>作者：</span>
            <el-tooltip :content="goodsInfo.author" placement="top" v-ak-tooltip-auto-show>
              <span class="ellipsis-aRow">{{
                goodsInfo.author || goodsInfo.textBooksAuthor || "-"
              }}</span>
            </el-tooltip>
          </div>
          <div v-if="
            goodsInfo.goodsType != 'paper' &&
            goodsInfo.goodsType != 'reference' &&
            goodsInfo.goodsType != 'other' &&
            goodsInfo.goodsType != 'looseleafOrtextbook'
          ">
            <span>出版社：</span>
            <el-tooltip :content="goodsInfo.publishingHouse" placement="top" v-ak-tooltip-auto-show>
              <span class="ellipsis-aRow">{{
                goodsInfo.publishingHouse == null ||
                  goodsInfo.publishingHouse == ""
                  ? "-"
                  : goodsInfo.publishingHouse
              }}</span>
            </el-tooltip>
          </div>
          <div v-if="
            goodsInfo.goodsType != 'paper' &&
            goodsInfo.goodsType != 'reference' &&
            goodsInfo.goodsType != 'learning' &&
            goodsInfo.goodsType != 'other'
          ">
            <span>出版时间：</span>
            <span class="ellipsis-aRow">{{
              goodsInfo.publishDate == null || goodsInfo.publishDate == ""
                ? "-"
                : goodsInfo.publishDate
            }}</span>
          </div>
          <div v-if="goodsInfo.goodsType == 'learning' || goodsInfo.goodsType == 'looseleafOrtextbook'">
            <span>ISBN：</span>
            <el-tooltip :content="goodsInfo.isbn" placement="top" v-ak-tooltip-auto-show>
              <span class="ellipsis-aRow">{{
                goodsInfo.isbn == null || goodsInfo.isbn == ""
                  ? "-"
                  : goodsInfo.isbn
              }}</span>
            </el-tooltip>
          </div>
          <div v-if="goodsInfo.goodsType == 'paper'">
            <span>教学属性：</span>
            <span class="ellipsis-aRow">{{
              goodsInfo.teachPropertyAllStr == null ||
                goodsInfo.teachPropertyAllStr == ""
                ? "-"
                : goodsInfo.teachPropertyAllStr
            }}</span>
          </div>
          <div v-if="goodsInfo.goodsType == 'paper'">
            <span>学科：</span>
            <span class="ellipsis-aRow">{{
              goodsInfo.subjectName == null || goodsInfo.subjectName == ""
                ? "-"
                : goodsInfo.subjectName
            }}</span>
          </div>
          <div v-if="goodsInfo.goodsType == 'paper'">
            <span>题目数量：</span>
            <span class="ellipsis-aRow">{{
              questionCount == null || questionCount == "" ? "-" : questionCount
            }}</span>
          </div>
        </div>
        <div class="book-intro-info">
          <div v-if="
            goodsInfo.goodsType == 'reference' ||
            goodsInfo.goodsType == 'other'
          ">
            <span>作者：</span>
            <el-tooltip :content="goodsInfo.author" placement="top" v-ak-tooltip-auto-show>
              <span class="ellipsis-aRow">{{
                goodsInfo.author || goodsInfo.textBooksAuthor || "-"
              }}</span>
            </el-tooltip>
          </div>
          <div v-if="
            goodsInfo.goodsType != 'paper' &&
            goodsInfo.goodsType != 'reference' &&
            goodsInfo.goodsType != 'learning' &&
            goodsInfo.goodsType != 'other' &&
            goodsInfo.goodsType != 'looseleafOrtextbook'
          ">
            <span>ISBN：</span>
            <el-tooltip :content="goodsInfo.isbn" placement="top" v-ak-tooltip-auto-show>
              <span class="ellipsis-aRow">{{
                goodsInfo.isbn == null || goodsInfo.isbn == ""
                  ? "-"
                  : goodsInfo.isbn
              }}</span>
            </el-tooltip>
          </div>
          <div v-if="goodsInfo.goodsType == 'learning'">
            <span>CN：</span>
            <el-tooltip :content="goodsInfo.cn" placement="top" v-ak-tooltip-auto-show>
              <span class="ellipsis-aRow">{{
                goodsInfo.cn == null || goodsInfo.cn == "" ? "-" : goodsInfo.cn
              }}</span>
            </el-tooltip>
          </div>
          <div v-if="goodsInfo.goodsType != 'paper'">
            <span>教学属性：</span>
            <span class="ellipsis-aRow">{{
              goodsInfo.teachPropertyAllStr == null ||
                goodsInfo.teachPropertyAllStr == ""
                ? "-"
                : goodsInfo.teachPropertyAllStr
            }}</span>
          </div>
          <div v-if="goodsInfo.goodsType != 'paper'">
            <span>提供机构：</span>
            <el-tooltip :content="goodsInfo.instName" placement="top" v-ak-tooltip-auto-show>
              <span class="ellipsis-aRow">{{
                goodsInfo.instName == null || goodsInfo.instName == ""
                  ? "-"
                  : goodsInfo.instName
              }}</span>
            </el-tooltip>
          </div>
          <div v-if="goodsInfo.goodsType == 'paper' && !questionBank">
            <span>考试时长：</span>
            <span class="ellipsis-aRow">{{
              goodsInfo.timeCount == null || goodsInfo.timeCount == ""
                ? "-"
                : goodsInfo.timeCount
            }}分钟</span>
          </div>
          <div v-if="goodsInfo.goodsType == 'paper' && !questionBank">
            <span>满分：</span>
            <span class="ellipsis-aRow">{{
              goodsInfo.fullScore == null || goodsInfo.fullScore == ""
                ? "-"
                : goodsInfo.fullScore
            }}分</span>
          </div>
          <div v-if="goodsInfo.goodsType == 'paper' && !questionBank">
            <span>及格分：</span>
            <span class="ellipsis-aRow">{{
              goodsInfo.passingScore == null || goodsInfo.passingScore == ""
                ? "-"
                : goodsInfo.passingScore
            }}分</span>
          </div>
          <div v-if="goodsInfo.goodsType == 'looseleafOrtextbook'"></div>
        </div>
        <div class="price" style="font-size: 32px;">
          <div v-if="!isShop" class="truePrice" v-show="goodsInfo.prices > 0"><span class="dollor"
              style="font-size:24px;">￥</span> {{
                goodsInfo.realPrice.toFixed(2)
              }}</div>
          <div v-if="!isShop" class="truePrice" v-show="goodsInfo.prices == 0">免费</div>
          <span v-if="isShop" class="havebuy">已购买</span>
          <span v-if="goodsInfo.prices > 0" :class="goodsInfo.prices == 0 ? 'yprice2' : 'yprice'">￥{{
            goodsInfo.prices.toFixed(2) }}</span>
          <div class="sale-volume">
            销量：{{
              goodsInfo.salesVolume == null || goodsInfo.salesVolume == 0
                ? 0
                : goodsInfo.salesVolume
            }}
            <div class="salebar" v-if="goodsInfo.salesVolume > 0"></div>
          </div>
        </div>
        <!-- <div class="sales">
          <div class="goods-score">
            商品评分：
            <el-rate v-model="goodsInfo.averageScore" disabled show-score text-color="#D81E06" :colors="colors"
              score-template="{value}分">
            </el-rate>
          </div>
        </div> -->
        <div class="share_box">
          <share :config="$store.state.read.config" @click="shareBook" />
        </div>

        <!-- <div class="integral-share">
          <div class="share-img">
            分享到
            <share :config="$store.state.read.config" @click="shareBook" />
          </div>
        </div> -->
        <!-- <el-divider></el-divider> -->
        <div v-if="questionBank" class="buttons questionBank_box">
          <el-button v-if="!isShop && goodsInfo.status != 5 && goodsInfo.status != 6" class="buyNow"
            :disabled="goodsInfo.status != 2" type="" @click="toPay()">
            <div style="display: flex; align-items: center; justify-content: center;"> 立即购买<img
                src="../../assets/images/bookdetail/toBuy.png" alt=""> </div>
          </el-button>
          <!-- <el-button v-if="!isShop && goodsInfo.status != 5 && goodsInfo.status != 6" :disabled="goodsInfo.status != 2"
            class="questionBank_but1" @click="addCart()"><img src="@/assets/icon/buycart.png" alt="" />加入购物车</el-button> -->
          <button class="sucessbtn tpPaper" type="success" v-if="
            goodsType == 'paper' &&
            isAnswer &&
            goodsInfo.status != 5 &&
            goodsInfo.status != 6
          " @click="goAnswer()">
            <div style="display: flex; align-items: center; justify-content: center;">
              <img src="../../assets/images/bookdetail/topaper.png" alt="">开始答题
            </div>
          </button>
          <div class="add" v-if="showLoginContent">
            <div class="addCart" v-if="!isShop && goodsInfo.status != 5 && goodsInfo.status != 6"
              :disabled="goodsInfo.status != 2" @click="addCart()">
              <img src="../../assets/images/bookdetail/addCart.png" alt="">
              加入购物车
            </div>
            <div class="addBook" @click="addBookshelf()">
              <img src="../../assets/images/bookdetail/addBook.png" alt="">
              {{ isBookshelf ? "已加入书架" : "加入书架" }}
            </div>
          </div>
        </div>
        <div class="buttons" v-if="!questionBank">
          <!-- 如果商品是内部上架状态，则禁用这些按钮 -->
          <el-button @click="onlinePreview(true)" class="see-online">
            <div style="display: flex; align-items: center; justify-content: center;"><img
                src="../../assets/images/bookdetail/onlineSeeNew.png" alt=""> 在线预览</div>
          </el-button>
        </div>

        <p style="font-weight: 400; font-size: 12px; color: #FF756B; line-height: 22px;">温馨提示：此类商品不支持退换货</p>
      </div>
      <!-- <div class="add">
        <div class="addCart" v-if="!isShop && goodsInfo.status != 5 && goodsInfo.status != 6"
          :disabled="goodsInfo.status != 2" @click="addCart()">
          <img src="../../assets/images/bookdetail/addCart.png" alt="">
          加入购物车
        </div>
        <div class="addBook" @click="addBookshelf()">
          <img src="../../assets/images/bookdetail/addBook.png" alt="">
          {{ isBookshelf ? "已加入书架" : "加入书架" }}
        </div>
      </div> -->
    </div>
    <div class="book-infos">
      <div class="left-book-detail">
        <el-tabs v-model="activeName">
          <!-- 内容简介 -->
          <el-tab-pane name="first">
            <span slot="label">内容简介</span>
            <content-intro :import-type="goodsType" :goods-info="goodsInfo" :source-list="sourceList"
              :subject-id="subjectId" :goods-id="goodsId" :pthis="pthis"></content-intro>
          </el-tab-pane>
          <!-- 图书目录 -->
          <el-tab-pane name="second" v-if="
            goodsInfo.goodsType != 'paper' &&
            goodsInfo.goodsType != 'looseleafOrtextbook'
          ">
            <span slot="label">图书目录</span>
            <div class="category" v-if="goodsInfo.directoryStructure != null">
              <el-input type="textarea" class="textareas mulu" :readonly="true" :value="goodsInfo.directoryStructure"
                :autosize="{ minRows: 0 }"></el-input>
            </div>

            <noData v-if="
              goodsInfo.directoryStructure == '' ||
              goodsInfo.directoryStructure == null
            "></noData>
          </el-tab-pane>
          <!-- 作者介绍 -->
          <el-tab-pane name="third" v-if="
            goodsInfo.goodsType != 'paper' &&
            goodsInfo.goodsType != 'looseleafOrtextbook'
          ">
            <span slot="label">作者介绍</span>
            <author-intro :data-list="authorList"></author-intro>
            <noData v-if="authorList == null || authorList.length == 0"></noData>
          </el-tab-pane>
          <!-- 评价 -->
          <el-tab-pane name="fourth">
            <span slot="label">评价 ( {{ total }} )</span>
            <evaluate-content :data-list="evaluateList" @refreshList2="refreshList2"></evaluate-content>
            <noData v-if="total == 0"></noData>
            <div class="pagination-box" v-show="total > 0">
              <el-pagination class="ou-pagination" background hide-on-single-page @size-change="handleSizeChange"
                @current-change="handleCurrentChange" :current-page="queryParams.pageNum"
                :page-sizes="[10, 20, 30, 40, 50]" :page-size="queryParams.pageSize"
                layout="total, prev, pager, next, sizes, jumper, slot" :total="total">
                <el-button @click="getList2()" class="ou-page-go">GO</el-button>
              </el-pagination>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
  </div>
</template>
<script>
import { OuchnOss } from "@/plugins/OuchnOss";
import { selQuestionTypeAndNumBySubject } from "@/api/answer/answer";
import { paperGetToken } from "@/api/index/index";
import { Utils } from 'elegant-tools-js';
import { setBrowserToken } from "@/utils/auth.js"

import {
  goodsInfoDetail,
  recommendGoods,
  recommendSubject,
  Listevaluate,
  CartAdd,
  BookshelfAdd,
  IsCartAdd,
  IsBookshelfAdd,
  checkIsBuy,
  delBookshelf,
  SelGoodsStatus,
  teachingAttrList,
} from "@/api/bookstore/bookstore";
import evaluateContent from "@/views/bookstore/detail/evaluateContent";
import authorIntro from "@/views/bookstore/detail/authorIntro";
import contentIntro from "@/views/bookstore/detail/contentIntro";
import noData from "@/components/noData.vue";
export default {
  data() {
    return {
      isShop: false,
      isAnswer: false,
      subjectId: null,
      showMore: false,
      colors: ["#D81E06", "#D81E06", "#D81E06"],
      isfold: true,
      isflag: 1,
      isBookshelf: false,
      isCart: false,
      keyword: [],
      goodsId: null,
      goodsType: null,
      goodsInfo: {}, //商品基本信息
      questionCount: "",
      sourceList: [], //资源文件
      authorInfo: {}, //作者简介
      total: 0,
      currentPage: 1,
      activeName: "first",
      value: 4.7,
      currImg: 0,
      evaluateList: [],
      coverFiles: [], //左侧商品图片数组
      recommendGoods: [], //推荐商品
      recommendGoodsOne: [],
      recommendSubject: [], //推荐专题
      authorList: [], //作者简介
      //查询参数
      queryParams: {
        pageNum: 1,
        pageSize: 10,
        goodsId: null,
        // type: "subject",
      },
      query: {
        goodsId: null,
        type: "goods",
      },
      payType: "goods",
      ouchnoss1: null,
      goodsTypeList: [],
      addCartState: true,
      courseList: [],
      paperList: [],
      questionBank: false,
      showLoginContent: false
    };
  },
  computed: {
    pthis() {
      return this;
    },
  },
  components: {
    evaluateContent,
    authorIntro,
    contentIntro,
    noData,
  },
  created() {
    this.$store.commit("subjectId_book", this.$route.query.goodsId);
    this.$store.commit("SET_ISLAYOUT", true);
    this.goodsId = this.$route.query.goodsId;
    this.goodsType = this.$route.query.goodsType;
    this.subjectId = this.$route.query.subjectId;
    this.getList();
    this.getList2();
    this.getoc_resource_file();
    if (localStorage.getItem("USERID")) {
      //判断是否加入书架
      this.isAddBookshelf();
      //判断是否加入购物车
      this.isAddCart();
    }
    this.ouchnoss1 = new OuchnOss(true);


                let info = {
                userId: this.$route.query.userId,
                goodsId: this.$route.query.goodsId,
                platform: this.$route.query.platform,
                browserFinger:Utils.getBrowserFingerprint()
                // timestamp: this.timestamp
            }
            setBrowserToken(JSON.stringify(info))
  },
  watch: {
    //监听路由变化
    $route() {
      if (this.$route.query.goodsId) {
        this.$store.commit("subjectId_book", this.$route.query.goodsId);
        this.goodsId = this.$route.query.goodsId;
        this.goodsType = this.$route.query.goodsType;
        this.isCart = false; //切换商品后未加入购物车时会提示已加入购物车
        this.getList();
        this.getList2();
      }
    },
  },
  methods: {
    // 根据学科查询题型及题型数量
    getQuestionNumber() {
      if (!this.goodsInfo.subjectId) return;
      let userId = this.$store.getters.userId;
      if (!userId) return;
      paperGetToken().then((token) => {
        selQuestionTypeAndNumBySubject(
          {
            subjectId: this.goodsInfo.subjectId,
          },
          token.data
        ).then((res) => {
          this.questionCount = res.data.reduce((pre, cur) => {
            return (pre += Number(cur.questionNum));
          }, 0);
        });
      });
    },
    //领取更多
    getMore() {
      this.$alert("此功能正在开发中，敬请期待", "提示信息");
    },
    enterShow() {
      if (this.goodsInfo.authorRecommendation.length > 135) {
        this.showMore = true;
      }
    },
    leaveShow() {
      this.showMore = false;
    },
    getList() {
      //商品基本信息
      goodsInfoDetail(this.goodsId).then((res) => {
        if (res.code == 200) {
          this.goodsInfo = res.data.goods;
          this.sourceList = res.data.sourceList;
          this.getQuestionNumber();
          if (res.data.sourceList.length > 0) {
            if (this.sourceList[0].resourceType == "bank") {
              this.questionBank = true;
            }
          }
          !this.goodsInfo.averageScore
            ? (this.goodsInfo.averageScore = 5)
            : this.goodsInfo.averageScore;
          if (this.goodsInfo.keyword) {
            this.keyword = this.goodsInfo.keyword.split(",");
          }
          this.coverFiles = res.data.coverFiles;
          if (this.coverFiles.length == 0) {
            let data = {
              fullUrl: require("@/assets/images/default_img.jpg"),
            };
            this.coverFiles.push(data);
          }
          this.authorList = res.data.authorList;
          let userId = this.$store.getters.userId;
          if (userId) {
            this.isPayGoods();
          }
        }
      });
      //推荐专题
      recommendSubject(this.goodsId).then((res) => {
        if (res.code == 200) {
          this.recommendSubject = res.data.slice(0, 2);
        }
      });
      //推荐商品
      recommendGoods(this.goodsId).then((res) => {
        if (res.code == 200) {
          this.recommendGoodsOne = res.data.slice(0, 1);
          this.recommendGoods = res.data.slice(1, 5);
        }
      });
    },
    //点击查看更多
    open() {
      this.isfold = !this.isfold;
      this.isfold === true ? (this.isflag = 1) : (this.isflag = 2);
    },
    shareBook() { },
    //获取评价列表
    getList2() {
      this.queryParams.goodsId = this.goodsId;
      Listevaluate(this.queryParams).then((res) => {
        if (res.code == 200) {
          this.evaluateList = res.rows;
          this.evaluateList.forEach((item) => {
            item.score = Number(item.score);
          });
          this.total = res.total;
        }
      });
    },
    //跳转到对应专题
    toDetail(id) {
      // console.log(id)
      this.$router.push({
        path: "/special/specialDetail",
        query: { subjectId: id },
      });
    },
    //跳转到对应商品
    toDetail1(id, type) {
      // console.log(id,type)
      this.$router.push({
        path: "/bookstore/bookstoreDetail",
        query: { goodsId: id, goodsType: type },
      });
    },
    //跳转到订单页
    toPay() {
      let userId = this.$store.getters.userId;
      if (!userId) {
        // let paramsJson = JSON.stringify({ goodsId: this.goodsId, goodsType: this.goodsType })
        this.$store.commit("SET_REDIRECTPARAMS", {
          goodsId: this.goodsId,
          goodsType: this.goodsType,
        });
        this.$router.push({
          path: "/login",
          query: {
            redirectPath: "/bookstore/bookstoreDetail",
            // queryParams: paramsJson,
          },
        });
      } else {
        //判断是否购买该商品
        this.payType = this.$route.query.payType
          ? this.$route.query.payType
          : "goods";
        checkIsBuy({ relevanceId: this.goodsId, type: this.payType }).then(
          (res) => {
            console.log("是否已购买响应", res);
            if (res.data === "2") {
              this.$message.error("数据异常");
              return;
            }
            if (res.data === "1") {
              SelGoodsStatus(this.goodsId).then((goodsState) => {
                if (goodsState.data.status == 2) {
                  this.$router.push({
                    path: "/submitOrder/index",
                    query: { id: this.goodsId, from: "bookstore" },
                  });
                  this.isShop = false;
                  this.isAnswer = false;
                } else {
                  this.$message("该商品已下架");
                }
              });
            } else {
              this.isShop = true;
              this.isAnswer = true;
              // this.$message("该商品已购买无需重复购买");
            }
          }
        );
      }
    },
    isPayGoods() {
      //判断是否已经购买该商品
      this.payType = this.$route.query.payType
        ? this.$route.query.payType
        : "goods";
      checkIsBuy({ relevanceId: this.goodsId, type: this.payType }).then(
        (res) => {
          console.log("是否已购买响应", res);
          if (res.data === "2") {
            this.$message.error("数据异常");
            return;
          }
          if (res.data === "1") {
            this.isShop = false;
            this.isAnswer = false;
          } else {
            this.isShop = true;
            this.isAnswer = true;
          }
        }
      );
    },
    //加入购物车
    addCart() {
      let userId = this.$store.getters.userId;
      if (!userId) {
        // let paramsJson = JSON.stringify({ goodsId: this.goodsId, goodsType: this.goodsType })
        this.$store.commit("SET_REDIRECTPARAMS", {
          goodsId: this.goodsId,
          goodsType: this.goodsType,
        });
        this.$router.push({
          path: "/login",
          query: {
            redirectPath: "/bookstore/bookstoreDetail",
            // queryParams: paramsJson,
          },
        });
      } else if (this.addCartState) {
        //加入购物车按钮 防止重复提交
        this.addCartState = false;
        checkIsBuy({ relevanceId: this.goodsId, type: this.payType }).then(
          (res) => {
            console.log("是否已购买响应", res);
            if (res.data === "2") {
              this.$message.error("数据异常");
              return;
            }
            if (res.data === "1") {
              if (!this.isCart) {
                SelGoodsStatus(this.goodsId).then((goodsState) => {
                  if (goodsState.data.status === 2) {
                    IsCartAdd(this.goodsId).then((res) => {
                      if (res.data) {
                        this.$message("该商品已经加入购物车");
                        return;
                      }
                      CartAdd(this.goodsId, userId).then((res) => {
                        if (res.code == 200) {
                          this.$store.commit(
                            "addGoodsIntoCartCart",
                            this.goodsId
                          );
                          this.$message({
                            message: "加入购物车成功",
                            type: "success",
                          });
                          this.isCart = true;
                        }
                      });
                    });
                  } else {
                    this.$message("该商品已下架");
                  }
                });
              } else {
                this.$message("该商品已经加入购物车");
              }
            } else {
              this.$message("该商品已购买无需再加入购物车");
            }
          }
        );
        setTimeout(() => {
          this.addCartState = true;
        }, 3000);
      }
    },
    //是否加入购物车
    isAddCart() {
      let userId = this.$store.getters.userId;
      IsCartAdd(this.goodsId).then((res) => {
        if (res.code == 200) {
          if (res.data) {
            // this.$message("您已经加入购物车");
            this.isCart = true;
          } else {
            this.isCart = false;
          }
        }
      });
    },
    //加入书架
    addBookshelf() {
      if (this.goodsInfo.status != 2) {
        this.$message("该商品已下架");
        return;
      }
      //判断是否登录
      let userId = this.$store.getters.userId;
      if (!userId) {
        this.$store.commit("SET_REDIRECTPARAMS", {
          goodsId: this.goodsId,
          goodsType: this.goodsType,
        });
        this.$router.push({
          path: "/login",
          query: {
            redirectPath: "/bookstore/bookstoreDetail",
            // queryParams: paramsJson,
          },
        });
      } else {
        this.query.goodsId = this.goodsId;
        if (!this.isBookshelf) {
          SelGoodsStatus(this.goodsId).then((goodsState) => {
            if (goodsState.data.status === 2) {
              BookshelfAdd(this.query).then((res) => {
                if (res.code == 200) {
                  this.$message({
                    message: "加入书架成功",
                    type: "success",
                  });
                  this.isBookshelf = true;
                }
              });
            } else {
              this.$message("该商品已下架");
            }
          });
        } else {
          // this.$message("该商品已经加入书架");
          //移出书架
          this.query.goodsId = this.goodsId;
          delBookshelf(this.query).then((res) => {
            if (res.data) {
              this.isBookshelf = false;
              this.$message({
                message: "移出书架",
                type: "success",
              });
            }
          });
        }
      }
    },
    // 是否加入书架
    isAddBookshelf() {
      this.query.goodsId = this.goodsId;
      IsBookshelfAdd(this.query).then((res) => {
        if (res.code == 200) {
          if (res.data) {
            // this.$message("该商品已经加入书架");
            this.isBookshelf = true;
          } else {
            this.isBookshelf = false;
          }
        }
      });
    },
    //手机端观看
    phoneLook() {
      this.$alert("此功能正在开发中，敬请期待", "提示信息");
    },
    //在线预览
    onlinePreview(e) {
      //判断是否登录
      // let userId = this.$store.getters.userId;

      let url =
        "/#/resourcesRead?goodsId=" +
        this.goodsId+'&browserFinger='+Utils.getBrowserFingerprint();
        window.open(url);
    },
    //开始考试
    goAnswer() {
      if (this.questionBank) {
        this.$router.push({
          path: "/bookstore/generateQuestion",
          query: {
            goodsId: this.goodsId,
            resourceType: "goods",
            resource: "bookCity",
            relevanceId: this.goodsId,
            bookName: this.goodsInfo.goodsTitle,
          },
        });
      } else {
        this.$router.push({
          path: "/bookstore/answer",
          query: {
            goodsId: this.goodsId,
            resourceType: "goods",
            resource: "bookCity",
            relevanceId: this.goodsId,
          },
        });
      }
    },
    handleSizeChange(val) {
      this.queryParams.pageSize = val;
      this.getList2();
      // console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      this.queryParams.pageNum = val;
      this.getList2();
    },
    changeSrc(index) {
      this.currImg = index;
    },
    share() {
      this.$alert("此功能正在开发中，敬请期待", "提示信息");
    },
    refreshList2() {
      this.getList2();
    },
    getoc_resource_file() {
      //来源
      teachingAttrList("oc_resource_file").then((res) => {
        this.goodsTypeList = res.data;
      });
    },
  },
};
</script>
<style scoped lang="scss">
.bookstore-detail {
  height: auto;
  padding-bottom: 40px;
  position: relative;
  z-index: 2;

  .top_back {
    background: url('../../assets/images/bookdetail/bookback.png');
    position: absolute;
    height: 440px;
    left: 0;
    right: 0;
    top: -30px;
    z-index: -1;
    background-position: center;
    background-size: 100% 100%;
  }

  .book-introduction {
    // margin-top: 36px;
    display: flex;
    width: 1200px;
    // min-height: 452px;
    background: #fffefd;
    margin: 24px auto 16px;
    box-sizing: border-box;
    padding: 24px;
    background: linear-gradient(180deg, #DEF3FF 4.29%, #FFFFFF 100%);
    box-shadow: 0px 6px 12px 0px rgba(0, 0, 0, 0.05);
    position: relative;

    // align-items: center;
    .left-demo-card {
      margin-right: 24px;
      width: 380px;

      .left-demo-body {
        // width: 380px;
        // height: 380px;
        padding: 16px 16px 25px;
        // background: #fff;
        // border: 1px solid #f2f2f2;
        border: 1px solid #B2C3CD;
        position: relative;
        border-radius: 4px;

        .left-demo-tag {
          position: absolute;
          left: 0;
          top: 11px;
          // width: 75px;
          padding: 0 7px;
          height: 22px;
          background: #1D87FF;
          border-radius: 0px 3px 3px 0px;
          border: 1px solid #2E9ADB;
          font-family: MiSans, MiSans;
          font-weight: 400;
          font-size: 14px;
          color: #FFFFFF;
          line-height: 22px;
          display: flex;
          align-items: center;

          img {
            margin-right: 9px;
            width: 12px;
            height: 14px;
          }
        }

        .left-img-box {
          width: 250px;
          height: 250px;
          background: #fbfbfb;
          margin-bottom: 27px;
          // margin: 5px auto 15px;

          img {
            width: 100%;
            height: 100%;
          }
        }

        .left-small-img {
          display: grid;
          grid-column-gap: 5px;
          grid-template-columns: repeat(4, calc(25% - 4px));
          box-sizing: border-box;
          // padding: 0 12px;

          img {
            width: 54px;
            height: 54px;
            // object-fit: scale-down;
            object-fit: cover;
            background: #fbfbfb;
          }

          .demo-card-box-img-checked {
            border: 1px solid #1890ff;
          }
        }
      }

      .left-demo-bottom {
        margin-top: 16px;
        display: flex;
        align-items: center;
        justify-content: space-between;

        >div {
          cursor: pointer;

          img {
            margin-right: 5px;
          }

          display: flex;
          align-items: center;
          font-size: 14px;
          font-family: PingFang SC;
          font-weight: 400;
          color: #999999;
        }
      }
    }

    .right-info {
      // width: 900px;
      position: relative;

      .title {
        margin-bottom: 9px;
        font-family: MiSans, MiSans;
        font-weight: 600;
        font-size: 20px;
        color: #191919;
        line-height: 26px;
        height: 52px;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
      }

      .book-intro {
        line-height: 20px;
        margin-bottom: 12px;
        font-size: 14px;
        font-family: PingFang SC;
        font-weight: 400;
        color: #626262;

        .defaultIntro {
          position: relative;
          // padding: 10px;
          box-sizing: border-box;

          .twointro {
            font-size: 13px;
            line-height: 22px;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
          }
        }

        .allIntro {
          position: absolute;
          left: 0;
          top: 0;
          background: #fffefd;
          z-index: 999;
          box-shadow: 0px 2px 5px 0px rgba(0, 0, 0, 0.1);
          border-bottom: 1px solid rgba(0, 0, 0, 0.1);
          padding: 10px;
          box-sizing: border-box;
        }

        .font {
          color: #2e9adb;
          text-decoration: underline;
          cursor: pointer;
        }
      }

      .label {
        display: flex;
        align-items: center;
        margin-bottom: 12px;
        flex-wrap: wrap;

        .label_item {
          background: linear-gradient(180deg, rgba(46, 154, 219, 0.15) 0%, rgba(103, 173, 247, 0.15) 100%);
          border-radius: 6px 6px 6px 6px;
          padding: 5px 8px;
          font-family: MiSans, MiSans;
          font-weight: 400;
          font-size: 12px;
          color: #2E9ADB;
          line-height: 22px;
          display: flex;
          align-items: center;
          justify-content: center;
          margin-right: 8px;
          margin-bottom: 8px;

          img {
            margin-right: 6px;
            width: 16px;
            height: 16px;
          }
        }


        // span {
        //   font-size: 14px;
        //   font-family: PingFang SC;
        //   font-weight: 400;
        //   color: #333333;
        //   background: #f2f2f2;
        //   border-radius: 6px;
        //   padding: 7px 10px;
        //   margin-right: 16px;
        //   box-sizing: border-box;
        //   display: block;
        //   margin-bottom: 8px;
        // }

        span:last-child {
          margin-right: 0;
        }
      }

      .book-intro-info {
        width: 850px;
        display: flex;
        align-items: center;

        // justify-content: space-between;
        >div {
          flex: 1;
          font-size: 14px;
          line-height: 19px;
          font-family: PingFang SC;
          font-weight: 400;
          color: #626262;
          display: flex;
          align-items: center;
          margin-bottom: 15px;
        }

        >div:nth-of-type(1) {
          span:last-child {
            width: 200px;
          }
        }

        >div:nth-of-type(2) {
          span:last-child {
            width: 200px;
          }
        }

        >div:nth-of-type(3) {
          span:last-child {
            width: 200px;
          }
        }
      }

      .price {
        font-size: 24px;
        font-family: PingFang SC;
        font-weight: 400;
        color: #ff5353;
        display: flex;
        margin: 16px 0 20px;
        align-items: baseline;

        .truePrice {
          font-size: 32px !important;
          background: linear-gradient(180deg, #FF6C00 0%, #FF1C1C 99%);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          background-clip: text;
          display: flex;
          font-weight: 600;
          align-items: baseline;

          .dollor {
            font-size: 24px !important;
          }

        }

        .havebuy {
          font-size: 24px;
          font-family: PingFang SC;
          font-weight: 400;
          color: #70b603;
        }

        .yprice {
          font-size: 14px;
          font-family: PingFang SC;
          font-weight: 400;
          text-decoration: line-through;
          color: #999999;
          margin-left: 12px;
          line-height: 19px;
        }

        .yprice2 {
          font-size: 14px;
          font-family: PingFang SC;
          font-weight: 400;
          text-decoration: line-through;
          color: #999999;
          margin-left: 12px;
          line-height: 19px;
        }

        .sale-volume {
          font-family: MiSans, MiSans;
          font-weight: 400;
          font-size: 14px;
          color: #FA1818;
          line-height: 19px;
          margin-left: 20px;
          display: flex;
          align-items: center;

          .salebar {
            width: 98px;
            height: 10px;
            background: linear-gradient(130deg, #FF3700 0%, #FFAA99 99.29%);
            border-radius: 22px;
            margin-left: 12px;
          }
        }
      }

      .sales {
        width: 850px;
        height: 20px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 12px;

        .sales-volume {
          display: flex;
          align-items: center;
          font-size: 13px;
          font-family: PingFang SC;
          font-weight: 400;
          color: #999999;
          cursor: pointer;

          img {
            width: 12px;
            height: 12px;
          }

          .quan1 {
            width: 54px;
            height: 16px;
            line-height: 16px;
            background: url("../../assets/icon/shape.png");
            text-align: center;
            font-size: 12px;
            font-family: PingFang SC;
            font-weight: 400;
            color: #ffffff;
            margin-right: 20px;
          }

          .quan2 {
            width: 81px;
            height: 16px;
            line-height: 16px;
            background: url("../../assets/icon/cshape.png");
            text-align: center;
            font-size: 12px;
            font-family: PingFang SC;
            font-weight: 400;
            margin-right: 13px;
            color: #ffffff;
          }
        }

        .goods-score {
          display: flex;
          font-size: 14px;
          font-family: PingFang SC;
          font-weight: 400;
          color: #333333;
          align-items: center;
        }
      }

      ::v-deep .share_box {
        position: absolute;
        background: linear-gradient(180deg, #DEF3FF 4.29%, #FFFFFF 100%);
        box-shadow: 0px 6px 12px 0px rgba(0, 0, 0, 0.05);
        border-radius: 8px 8px 8px 8px;
        padding: 12px;
        top: -24px;
        right: -88px;

        .social-share-icon {
          width: 24px;
          height: 24px;
        }

        a {
          margin: 0 0 16px 0;
        }

        a:last-child {
          margin-bottom: 0;
        }

        img {
          width: 24px;
          height: 24px;
          margin-top: 16px;
        }

        .social-share {
          display: flex;
          flex-direction: column;

          .wechat-qrcode {
            width: 146px;

            h4 {
              display: none;
            }

            .qrcode {
              height: 122px;
              width: 119px;

              img {
                width: 100%;
                height: 100%;
              }
            }

          }
        }
      }



      .integral-share {
        width: 850px;
        display: flex;
        align-items: center;
        height: 18px;
        justify-content: space-between;

        .double-sales {
          display: flex;
          align-items: center;
          font-size: 13px;
          font-family: PingFang SC;
          font-weight: 400;
          color: #999999;

          .integral {
            margin-left: 60px;
          }
        }

        .share-img {
          font-size: 14px;
          font-family: PingFang SC;
          font-weight: 400;
          color: #999999;
          display: flex;
          align-items: center;

          img {
            width: 18px;
            height: 18px;
            margin-left: 8px;
            cursor: pointer;
          }
        }
      }

      .el-divider--horizontal {
        margin: 16px 0;
      }

      .buttons {
        display: flex;
        align-items: center;
        margin-bottom: 6px;
        position: relative;
        width: 100%;

        .add {
          position: absolute;
          // bottom: 32px;
          right: -18px;

          .addBook,
          .addCart {
            display: flex;
            align-items: center;
            justify-content: center;
            padding: 8px 16px;
            background: rgba(241, 127, 83, 0.1);
            border-radius: 32px 0px 0px 32px;
            font-family: MiSans, MiSans;
            font-weight: 400;
            font-size: 14px;
            color: #F17F53;
            line-height: 20px;
            cursor: pointer;

            img {
              width: 16px;
              height: 16px;
              margin-right: 4px;
            }

          }

          .addBook {
            margin-top: 12px;
            background: rgba(46, 154, 219, 0.1);
            color: #2E9ADB;
          }
        }

        .el-button {
          margin-right: 12px;
          width: 180px;
          height: 45px;
          display: flex;
          align-items: center;
          justify-content: center;
          font-family: MiSans, MiSans;
          font-weight: 400;
          font-size: 18px;
          line-height: 24px;

          span {}

          img {
            width: 24px;
            height: 24px;
            display: block;
            margin-right: 4px;
          }
        }

        .see-online {
          background: rgba(0, 129, 206, 0.1);
          color: #0081CE;
        }

        .buyNow {
          background: linear-gradient(0deg, #1B3FC6 0%, #0081CE 98.57%);
          font-weight: 600;
          font-size: 18px;
          color: #FFFFFF;
          line-height: 24px;

          img {
            margin-left: 16px;
            margin-right: 0;
          }
        }


        .sucessbtn {
          width: 180px;
          height: 45px;
          border-radius: 6px;
          border: none;
          font-family: PingFang SC;
          font-weight: 400;
          font-size: 18px;
          color: #0081CE;
          line-height: 24px;
          cursor: pointer;
          margin-right: 12px;

          img {
            width: 24px;
            height: 24px;
            display: block;
            margin-right: 4px;
          }
        }

        .seeNow {
          background: rgba(0, 129, 206, 0.1);
          color: #0081CE;
        }

        .tpPaper {
          background: #D2F4D4;
          color: #257328;
        }

        .offShelfbtn {
          width: 180px;
          height: 45px;
          background: #E8E8E8;
          font-family: MiSans, MiSans;
          font-weight: 400;
          font-size: 18px;
          color: #808080;
          line-height: 24px;
          text-align: left;

          img {
            width: 24px;
            height: 24px;
            display: block;
            margin-right: 4px;
          }
        }

        // .el-button {
        //   width: 160px;
        //   height: 40px;
        //   border: 1px solid #f6a200;
        //   background: #fffefd;
        //   border-radius: 6px;
        //   box-sizing: border-box;

        // }

        // .el-button:first-child {
        //   border: 1px solid #2e9adb;
        //   border-radius: 6px 0px 0px 6px;
        // }

        // .el-button:nth-child(2) {
        //   background: #2e9adb;
        //   border-radius: 0px 6px 6px 0px;
        //   border: 1px solid #2e9adb;
        //   margin-left: -1px;
        //   margin-right: 20px;
        // }

        // .el-button:last-child {
        //   line-height: 40px;
        //   font-size: 16px;
        //   font-family: PingFang SC;
        //   font-weight: bold;
        //   color: #f6a200;
        //   padding-top: 0;

        //   img {
        //     width: 16px;
        //     height: 16px;
        //     margin-right: 8px;
        //   }
        // }
      }

      p {
        font-size: 14px;
        font-family: PingFang SC;
        font-weight: 400;
        color: #999999;
      }
    }


  }

  .book-infos {
    width: 1200px;
    min-height: 500px;
    margin: 0 auto 20px;
    display: flex;

    .left-book-detail {
      width: 100%;
      //width: 1080px;
      min-height: 500px;
      // margin-right: 16px;
      background: #fffefd;
      box-sizing: border-box;
      // padding: 5px 20px 30px;
      padding: 24px;

      ::v-deep .el-tabs__nav-wrap {
        padding-left: 20px;

        .el-tabs__active-bar {
          background: #1D87FF;
          height: 3px;
        }

        .el-tabs__item {
          font-family: MiSans, MiSans;
          font-weight: 400;
          font-size: 16px;
          color: #626262;
          // line-height: 21px;
        }

        .el-tabs__item.is-active {
          color: #191919;
          font-family: MiSans, MiSans;
          font-weight: 500;
          font-size: 16px;
          color: #191919;
          // line-height: 21px;
        }
      }

      ::v-deep .category {
        box-sizing: border-box;
        // padding: 15px 50px 0;
        overflow: hidden;

        .el-textarea__inner {
          padding: 0;
          font-family: MiSans, MiSans;
          font-weight: 400;
          font-size: 13px;
          color: #3D3D3D;
          line-height: 24px;
        }
      }

      .show-more {
        display: flex;
        align-items: center;
        margin-top: 15px;
        font-size: 14px;
        font-family: PingFang SC;
        font-weight: 400;
        color: #33649f;
        justify-content: flex-end;
        cursor: pointer;

        img {
          width: 13px;
          height: 14px;
          margin-left: 7px;
        }
      }
    }

    .right-recommend {
      width: 304px;

      .recommend-special {
        width: 304px;
        min-height: 340px;
        background: #fffefd;
        margin-bottom: 16px;
        box-sizing: border-box;
        padding: 13px 22px 10px;

        .title {
          font-weight: bold;
        }

        .recommend-book {
          margin-top: 16px;
          width: 260px;
          height: 280px;
          background: #ffffff;
          border: 1px solid #f2f2f2;

          .img {
            width: 260px;
            height: 195px;
            cursor: pointer;

            img {
              width: 100%;
              height: 100%;
            }
          }

          .book-title {
            line-height: 18px;
            height: 16px;
            font-size: 16px;
            font-family: PingFang SC;
            font-weight: 400;
            color: #333333;
            margin: 15px 0;
            margin-left: 5px;
            width: 250px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            cursor: pointer;
          }

          .book-info {
            display: flex;
            align-items: center;
            justify-content: space-between;
            height: 28px;

            .left-label {
              width: 100px;
              height: 28px;
              background: #ffffff;
              border: 1px solid #0081ce;
              border-radius: 6px;
              font-size: 14px;
              font-family: PingFang SC;
              font-weight: 400;
              color: #0081ce;
              text-align: center;
              line-height: 28px;
              margin-left: 6px;
            }

            .price {
              font-family: PingFang SC;
              font-weight: 400;
              color: #ff5353;
              margin-right: 20px;
              display: flex;
              align-items: center;

              .truePrice {
                font-size: 32px !important;
                background: linear-gradient(90deg, #FF6C00 0%, #FF1C1C 99%);
                -webkit-background-clip: text;
                -webkit-text-fill-color: transparent;
                background-clip: text;
                display: flex;

                .dollor {
                  font-size: 24px !important;
                }

              }

              .sellprice {
                display: inline-block;
                max-width: 82px;
              }

              .yprice {
                font-size: 12px;
                font-family: PingFang SC;
                font-weight: 400;
                text-decoration: line-through;
                color: #999999;
                max-width: 64px;
                display: inline-block;
              }

              .yprice2 {
                font-size: 12px;
                font-family: PingFang SC;
                text-decoration: line-through;
                font-weight: 400;
                // text-decoration: none;
                color: #999999;
                max-width: 64px;
                display: inline-block;
              }
            }
          }
        }
      }

      .recommend-resource {
        width: 304px;
        min-height: 250px;
        background: #fffefd;
        box-sizing: border-box;
        padding: 13px 22px 10px;

        .title {
          font-weight: bold;
        }

        .title::before {
          background: #f6a200;
        }

        .recommend-book {
          margin-top: 14px;

          .img {
            width: 143px;
            height: 143px;
            display: flex;
            margin: 0 auto;
            align-items: center;
            justify-content: center;
            background: #ffffff;
            border: 1px solid #f2f2f2;
            margin-bottom: 16px;
            cursor: pointer;

            img {
              width: 100%;
              height: 100%;
            }
          }

          .book-title {
            display: flex;
            align-items: center;
            max-width: 280px;
            justify-content: center;
            font-size: 14px;
            font-family: PingFang SC;
            font-weight: 400;
            color: #333333;
            margin-bottom: 11px;
            cursor: pointer;

            p {
              max-width: 216px;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }

            img {
              width: 27px;
              height: 20px;
              margin-right: 4px;
            }
          }

          .catalogue {
            .content-item {
              height: 43px;
              box-sizing: border-box;
              font-size: 14px;
              font-family: PingFang SC;
              font-weight: 400;
              color: #333333;
              border-top: 1px solid #f2f2f2;
              padding: 14px 16px;
              position: relative;
              width: 250px;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
              cursor: pointer;

              span {
                display: inline-block;
                max-width: 240px;
                height: 14px;
                line-height: 14px;
              }
            }

            .content-item::before {
              content: "";
              display: block;
              width: 5px;
              height: 5px;
              background: #0084d2;
              border-radius: 50%;
              position: absolute;
              left: 4px;
              top: 19px;
            }

            .content-item:last-child {
              padding-bottom: 0;
            }
          }
        }
      }
    }
  }
}

.pagination-box {
  margin-top: 30px;
  text-align: right;
}

.mulu ::v-deep .el-textarea__inner {
  border: none;
  background: #fffefd;
  resize: none;
}

::v-deep .el-tabs__nav-wrap {
  .el-tabs__item {
    span {
      font-size: 16px;
    }
  }
}




.border-disable {
  color: #999999 !important;
  border: 1px solid #999999 !important;
}

.bgcolor-disalbe {
  background: #999999 !important;
  color: #ffffff;
  border: 1px solid #999999 !important;
}

.questionBank_but {
  width: 160px;
  height: 42px;
  background: #2e9adb;
  border-radius: 6px 6px 6px 6px;
}

.questionBank_but1 {
  font-size: 16px;
  font-family: PingFang SC;
  font-weight: bold;
  color: #f6a200;
  width: 160px;
  height: 42px;
  border: 1px solid #f6a200;

  img {
    width: 16px;
    height: 16px;
    margin-right: 8px;
  }
}

.questionBank_box {
  display: flex;
  flex-direction: row;
  align-items: center;
  margin: 5px 0 10px 0px;
}
</style>
